var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Field } from 'formik';
import React from 'react';
import { DuoColumnSelector } from './DuoColumnSelector';
export var DuoColumnSelectorContainer = function (props) {
    return React.createElement(Field, __assign({}, props, { component: DuoColumnSelector }));
};
DuoColumnSelectorContainer.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=DuoColumnSelectorContainer.js.map